import React from 'react';
import './ValuationAndArea.scss';

const RealEstateSection = () => {
return (
  <section className="valuation-professional-marketing">
    <div className="valuation-container">
      <div className="valuation-heading">
        <h2>Expert Valuations From Local Knowledge</h2>
        <p className="valuation-subtitle">Discover Your Property’s True Value</p>
      </div>
      <div className="valuation-content">
        <div className="valuation-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Ffree-valuation-estate-agent.jpg?alt=media&token=9115054e-37e7-4e62-8616-c3ba702d7e5e" alt="House Tour" className="valuation-image" />
        </div>
        <div className="valuation-text-content">
        <h3>Start Your Property Journey <br />With A <span className="orange-text">Free Valuation</span></h3>
          <p>
          Every new journey begins with a single step and when it comes to selling or letting your property; the first step is understanding its value.  That’s why we provide a no-obligation, free valuation conducted by one of our experienced experts.  This service offers you a stress-free way to determine your property’s worth and plan your next move confidently.
          </p>
        </div>
      </div>
      {/* <div className="valuation-content valuation-video-content">
        <div className="valuation-slideshow-container">
             <iframe
              // src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d166845.38070620378!2d-1.7313394509429403!3d54.90613836897785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1syour%20move!5e0!3m2!1sen!2suk!4v1720716259907!5m2!1sen!2suk"
              src="https://www.google.com/maps/d/u/0/embed?mid=1D_G30-qPlRYyUpuxZ_7SjtPHEpXCrlU&ehbc=2E312F&noprof=1"
              width="600"
              height="350"
              style={{ border: '0', borderRadius: '10px'}}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="section-image"
              title="Google Maps Embed">
            </iframe>
        </div>
        <div className="valuation-text-content">
          <h3>Areas We Cover</h3>
          <p>
          Operating under the Your Move brand, Chris Stonock is an independently owned franchise with 14 branches located across the North-East including Chester-le-Street, Consett, Crawcrook, Durham, Houghton-le-Spring, Low Fell, Rowlands Gill, Sunderland, Wallsend, Whickham, Whitley Bay and Winlaton.  We are passionate about the areas we service and take pride in our local knowledge.
          </p>
        </div>
      </div> */}
    </div>
  </section>
);
};
export default RealEstateSection;
